<style scoped>
.full-width {
  width: 100%;
}
</style>
<template>
  <v-card outlined>
    <v-card-title class="text-subtitle-1 font-weight-bold">{{
      $t('distribution.qrCode.title')
    }}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-card
            class="mx-4 flat flex-grow-1 d-flex flex-column"
            color="blue-grey lighten-5"
            flat
            rounded="lg"
          >
            <v-card-text>
              {{ $t('distribution.qrCode.description') }}
            </v-card-text>
            <div class="d-flex justify-center pb-4">
              <div ref="qrCodeContainer">
                <qrcode-vue :value="qrCodeValue" :size="size" level="H" />
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="6" class="d-flex flex-column justify-center">
          <div class="d-flex justify-center full-width">
            <v-btn
              block
              depressed
              outlined
              color="blue-grey darken-5"
              class="ma-2"
              @click="printQR"
              :disabled="!classCode"
            >
              <v-icon class="mr-2" size="large">mdi-printer-outline</v-icon>
              {{ $t('distribution.qrCode.buttonText.1') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import QrcodeVue from "qrcode.vue";
import { getDistributionUrl } from "@/utils/distributionUtils";

export default defineComponent({
  name: "QRCode",
  components: {
    QrcodeVue,
  },
  props: {
    classCode: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    size: 200,
  }),
  computed: {
    qrCodeValue(): string {
      return getDistributionUrl(this.classCode);
    },
  },
  methods: {
    async printQR() {
      if (!this.classCode) {
        return;
      }

      try {
        const html2canvas = await import("html2canvas");
        const qrContainer = this.$refs.qrCodeContainer as HTMLElement;

        if (!qrContainer) {
          throw new Error("QR code container not found");
        }

        const canvas = await html2canvas.default(qrContainer, {
          backgroundColor: "#ffffff",
          scale: 2,
        });

        const printWindow = window.open("", "_blank");
        if (!printWindow) {
          throw new Error("Could not open print window");
        }

        printWindow.document.write(`
          <html>
            <head>
              <title>QR Code - ${this.classCode}</title>
              <style>
                body {
                  margin: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100vh;
                  flex-direction: column;
                }
                h2 {
                  text-align: center;
                  margin-bottom: 20px;
                  font-family: Arial, sans-serif;
                }
                img {
                  max-width: 100%;
                  height: auto;
                }
              </style>
            </head>
            <body>
              <h2>Class Code: ${this.classCode}</h2>
              <img src="${canvas.toDataURL("image/png")}" alt="QR Code" />
            </body>
          </html>
        `);

        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 250);

        this.$root.$emit("showSnackbar", {
          message: this.$t("distribution.qrCode.printSuccess"),
          color: "success",
        });
      } catch (error) {
        console.error("Error printing QR code:", error);
        this.$root.$emit("showSnackbar", {
          message: this.$t("distribution.qrCode.printError"),
          color: "error",
        });
      }
    },
  },
});
</script>
